import { render, staticRenderFns } from "./sidebarmodenew.vue?vue&type=template&id=5c4b7fee&scoped=true&"
import script from "./sidebarmodenew.vue?vue&type=script&lang=js&"
export * from "./sidebarmodenew.vue?vue&type=script&lang=js&"
import style0 from "./sidebarmodenew.vue?vue&type=style&index=0&id=5c4b7fee&lang=less&scoped=true&"
import style1 from "./sidebarmodenew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4b7fee",
  null
  
)

export default component.exports